import React from 'react';
import SubPage from '../components/site/SubPage';
import { PageSection, PageTitleBox } from '../components/site/SubPageParts';

const IMG = '/images/site/company';
const ORANGE = '#E2762B';
const NAVY = '#213D61';

const CRITERIA = [
  <>
    <strong>Nonprofits</strong> (often requiring 501(c)(3) status)
  </>,
  'On company letterhead, detail the organization’s mission, vision and focus.',
  'Proof of legal status (e.g., tax-exempt certification for nonprofits).',
  'Evidence-based impact: Applicants must demonstrate how the funds provide value to solve the problem.',
];

const REVIEW_PROCESS = [
  'Grants are awarded annually on an impact and need basis. Current grantees must resubmit yearly; a current grant does not automatically guarantee eligibility for new funding.',
  'The application window opens on the 1st and runs through the 31st of January 2027, closing at 11:59 PM EST or when the maximum number of applications has been received, whichever comes first.',
  'Applications are reviewed in the order they are received.',
  'Applicants will be notified of the funding decision within approximately one month of the application being submitted.',
  'All required application materials must be submitted before the application period closes. When applications are closed, you will not be able to submit another application.',
];

const Heading = ({ children, className = '' }) => (
  <h2 className={`text-[20px] font-bold text-black md:text-[24px] ${className}`}>/ {children}</h2>
);

const BulletList = ({ items }) => (
  <ul className="mt-4 list-disc space-y-2 pl-6 text-[15px] leading-relaxed text-black md:text-[18px]">
    {items.map((item, i) => (
      <li key={i}>{item}</li>
    ))}
  </ul>
);

const PhilanthropyGrants = () => (
  <SubPage title="Philanthropy Grants">
    <PageTitleBox>/ Philanthropy Grants.</PageTitleBox>

    {/* Mesh band runs edge to edge behind the top of the card. The art is
        stretched to the band (object-fill, not cover) so the whole wave shows
        instead of losing its bottom edge. */}
    <div className="relative mt-6 md:mt-8">
      <img
        src={`${IMG}/grants-mesh.jpeg`}
        alt=""
        aria-hidden="true"
        className="absolute inset-x-0 top-0 aspect-[11/5] max-h-[680px] w-full object-fill"
      />

      <PageSection className="relative pt-4 md:pt-5">
        <div
          className="mx-auto max-w-[1080px] border bg-white px-5 py-7 md:px-10 md:py-9"
          style={{ borderColor: NAVY }}
        >
          <Heading>Grant criteria.</Heading>

          <p
            className="mt-5 max-w-[900px] rounded-[10px] px-4 py-4 text-[15px] text-white md:text-[17px]"
            style={{ backgroundColor: ORANGE }}
          >
            2026 application window is closed.
          </p>

          <BulletList items={CRITERIA} />

          <Heading className="mt-9">Review process.</Heading>
          <BulletList items={REVIEW_PROCESS} />

          <Heading className="mt-9">Get in touch.</Heading>
          <p className="mt-4 max-w-[60ch] text-[15px] leading-relaxed text-black md:text-[18px]">
            For further support or general inquiries, please do not hesitate to contact the NuVola
            AI team.
          </p>

          <a
            href="mailto:philanthropy@nuvolaai.com?subject=Philanthropy%20Grants"
            className="mt-8 inline-block rounded-[10px] border border-black px-14 py-3 text-[16px] text-black transition-colors hover:bg-black hover:text-white md:text-[18px]"
          >
            Contact us
          </a>
        </div>
      </PageSection>
    </div>
  </SubPage>
);

export default PhilanthropyGrants;
